"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GlobalCss_1 = require("./GlobalCss");
Object.defineProperty(exports, "GlobalCss", { enumerable: true, get: function () { return GlobalCss_1.GlobalCss; } });
Object.defineProperty(exports, "DefaultGlobalCss", { enumerable: true, get: function () { return GlobalCss_1.DefaultGlobalCss; } });
//# sourceMappingURL=index.js.map